import React from "react";

import { useExperience } from "@/context/ExperienceContext";
import { useMapContext } from "@/finder/googleMaps/GoogleMapsProvider";

import { reverseGeocode } from "../../utils";
import { useFinder } from "./useFinder";

const useSearchThisArea = (searchMarker: HTMLDivElement | null, isMobileView: boolean) => {
  const { getMapCenter, pixelToCoordinate } = useMapContext();
  const { country, language } = useExperience();

  const { noResultsFound, locationSearchOptionSet } = useFinder();

  const runSearchThisArea = React.useCallback(async () => {
    if (!country || !language) {
      return;
    }
    try {
      const mapContainer = document.querySelector(".gm-style");
      const getSearchCoordinates = () => {
        if (!searchMarker || !mapContainer) {
          return getMapCenter(); // Fallback to map center
        }

        const markerRect = searchMarker.getBoundingClientRect();
        const mapRect = mapContainer.getBoundingClientRect();

        const offsetX = markerRect.left - mapRect.left + markerRect.width / 2;
        const offsetY = markerRect.top - mapRect.top + markerRect.height / 2;

        return !noResultsFound && !isMobileView
          ? pixelToCoordinate(offsetX, offsetY)
          : getMapCenter();
      };

      const { lat, lon } = getSearchCoordinates();

      const geoPlace = await reverseGeocode({ lat, lon, country, language });

      if (!geoPlace) {
        throw new Error("Failed to reverse geocode");
      }

      const id = `map_${lat}_${lon}_${geoPlace.address}`;

      locationSearchOptionSet({
        label: geoPlace.address,
        value: id
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error in mapBasedSearch:", error);
    }
  }, [
    country,
    language,
    getMapCenter,
    pixelToCoordinate,
    searchMarker,
    noResultsFound,
    isMobileView,
    locationSearchOptionSet
  ]);

  return {
    runSearchThisArea
  };
};

export default useSearchThisArea;
